import { Component, ElementRef, OnInit, ViewChild, TemplateRef, ViewChildren, EventEmitter, Output, OnChanges, SimpleChanges, OnDestroy, Input, ViewEncapsulation, AfterContentInit, AfterViewInit } from '@angular/core';
import { VideoSDK } from '@videosdk.live/js-sdk';
import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateGroupPopupComponent } from './create-group-popup/create-group-popup.component';
import { GroupSharingService, WatchPartyType } from './group-sharing.service.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompatClient, Stomp } from '@stomp/stompjs';
import { WebsocketListener } from 'src/app/core/models/websocket.model';
import { FormControl } from '@angular/forms';
import { EMPTY, Observable } from 'rxjs';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { CommonDialogComponent } from './common-dialog/common-dialog.component';
import { HotToastService } from '@ngneat/hot-toast';
import { InvitationSource, WatchPartyRequestFlow } from 'src/app/core/models/common.models';
import { UserInvitationService } from 'src/app/core/services/user.invitation.service';
export interface User {
  name: string;
  value: string;
  id: string;
  userId: string
}

@Component({
  selector: 'app-group-share',
  templateUrl: './group-sharing.component.html',
  styleUrls: ["./group-sharing.component.scss"]
})

export class GroupSharingComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  AUTH_URL = "";
  API_BASE_URL = "https://api.videosdk.live";
  @ViewChild('videoContainer', { static: false }) videoContainer: ElementRef | undefined;
  @ViewChild('createGroup') groupTemplate: TemplateRef<any>;
  @ViewChild('waitingLobby') waitingLobbyTemplate: TemplateRef<any>;
  @ViewChild('participantList') participantListTemplate: TemplateRef<any>;

  @ViewChildren('videoContainer') nameItems: ElementRef;
  @ViewChild('participantsList') participantsList: TemplateRef<any>;
  @ViewChild('listLocalAudio') listLocalAudio: TemplateRef<any>;
  token: string = "";
  meeting: any;
  localParticipant: any;
  localParticipantAudio: any;
  meetingId: any;
  micEnable: boolean = true;
  participantId: any;
  openChat: boolean = false;
  meetingStarted: boolean = false;
  webCamEnable: boolean = true;
  webCamToggleIcon: string = 'videocam';
  micToggleIcon: string = 'mic';
  userDetails: any = [];
  @Input() eventId: any = '';
  @Output() isGroupShareActive = new EventEmitter<string>();
  public messages: any;
  //icons path
  videocam_on = "assets/icons/group-sharing/videocam.svg"
  videocam_off = "assets/icons/group-sharing/videocam_off.svg"
  mic_on = "assets/icons/group-sharing/mic.svg"
  mic_off = "assets/icons/group-sharing/mic_off.svg"
  menu_icon = "assets/icons/group-sharing/more_vert.svg"
  myControl = new FormControl();
  selectedUsers: any = [];
  selectedUsersIds: any = [];
  filteredOptions: Observable<User[]>;
  videoElement: any;
  joinStream: any;
  videoParticipantContainer: any;
  hostUserId: string;
  hostUser: boolean = false;
  hostUserCustomId: string;
  joinEventDetails: any;
  customRoomId: string;
  totalParticipant: any = 1;
  eventDetails: any;
  permissionAllowed: boolean = false;
  webcams: any = []
  userJoinType: string;
  canUserAccessMovie: boolean = false;
  message: string = '';
  private readonly socketListeners: Record<keyof typeof WebsocketListener | string, CompatClient> = {};
  constructor(
    public bottomSheet: MatBottomSheet,
    private toast: HotToastService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private sportLightService: SpotlightService,
    private router: Router,
    private groupSharingService: GroupSharingService,
    private route: ActivatedRoute,
    private userInvitationService: UserInvitationService) {

    this.eventId = route.snapshot.params.id;
    this.getStreamingLink()

  }


  async ngOnInit() {
    console.log('')
    this.getUserDetails()
    this.eventId = this.route.snapshot.params.id;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        return this.filter(val || '')
      })
    )
    this.getEventDetails()

  }

  ngAfterViewInit() {
    console.log('afterviewinit')
    // if (localStorage.getItem('meetingDetails')) {
    //   let data = JSON.parse(localStorage.getItem("meetingDetails"))
    //   this.customRoomId = data.customRoomId
    //   console.log(data.isAdmin, 'isAdmin')
    //   if (data.isAdmin) {
    //     setTimeout(() => {
    //       this.startMeeting(data.token, data.meetingId)
    //     }, 4000);
    //   } else {
    //     setTimeout(() => {
    //       this.userJoinMeeting(data)
    //     }, 4000)
    //   }
    // }
    if (localStorage.getItem('meetingDetails')) {
    //  this.isSessionAvailable = true;
      this.sportLightService.getUserDetails().toPromise().then((res: any) => {

          //   this.firstName = (res.firstName).toUpperCase();
          this.userDetails = res;
          this.eventId = JSON.parse(localStorage.getItem('meetingDetails'))?.eventId;
          res['userId'] = res?.userID ? res.userID : res.userId
          localStorage.setItem('userData', JSON.stringify(res));
          this.groupSharingService.getActiveWatchParty(this.eventId).subscribe((res) => {
              let item;
              // this.eventDetails = res;
              const value: any = JSON.parse(localStorage.getItem('meetingDetails'));
              if (value) {
                  this.token = value.token;
                  this.meetingId = value.meetingId;
                  this.customRoomId = value.customRoomId
              }
              let userDetails = JSON.parse(localStorage.getItem('userData'))
              if (res) {
                  item = res.find((v) => v.customRoomId == this.customRoomId)
              }
              this.eventDetails = item;
              this.hostUserId = item.userId
              this.hostUserCustomId = item.userId + '-sss'
              if (userDetails.userId === item.userId) {

                  this.hostUser = true;
              } else {
                  this.hostUser = false;
              }
              this.selectedUsers = this.eventDetails.participants;
              if (localStorage.getItem('meetingDetails')) {
                  if (value.isAdmin) {
                      setTimeout(() => {
                          this.meetingStarted = true;
                          this.startMeeting(value.token, value.meetingId)

                      }, 2000)
                  } else {
                      setTimeout(() => {
                          this.userJoinMeeting(value)
                      }, 5000)
                  }
              }
          }, err => {

          })
      }).catch((err: any) => {

      });
  }
  }

  async startMeeting(token: any, meetingId: any) {
    // Meeting config
    console.log('start meeting')
    VideoSDK.config(token);
    this.meetingId = meetingId

    this.meeting = VideoSDK.initMeeting({
      meetingId: meetingId, // required
      name: (this.userDetails.firstName + ' ' + this.userDetails.lastName).toUpperCase(), // required
      micEnabled: true, // optional, default: true
      webcamEnabled: true, // optional, default: true
      maxResolution: "hd", // optional, default: "hd"
      // token: token,
      participantId: this.userDetails.userId + '-sss'
    });
    await this.createLocalParticipant(this.meeting)

    this.webcams = await this.meeting?.getWebcams();
    const { deviceId, label } = this.webcams[0]
    this.meeting?.changeWebcam(deviceId);
      this.meeting.join()
    this.meeting.localParticipant.on("stream-enabled", (stream: any) => {

      this.joinStream = stream;

      if (stream.kind === "video") {
        this.webCamEnable = true;
        let toggleIcon = document.getElementById(`iconvideov-${this.participantId}`);
        if (toggleIcon) {
          toggleIcon.innerHTML = 'videocam';

        }
        let toggleIcon1: any = document.getElementById(`loclistvideo-${this.participantId}`);
        if (toggleIcon1) {
          toggleIcon1.src = this.videocam_on;
        }
        this.setTrack(
          stream,
          this.localParticipantAudio,
          this.meeting.localParticipant,
          true
        );
      }
      if (stream.kind == "audio") {
        this.micEnable = true;
        let toggleIcon = document.getElementById(`iconaudiov-${this.participantId}`);
        let toggleIcon1: any = document.getElementById(`loclistmic-${this.participantId}`);
        if (toggleIcon) {
          toggleIcon.innerHTML = 'mic';
        }
        if (toggleIcon1) {
          toggleIcon1.src = this.mic_off;
        }
      }

    });

    this.meeting.localParticipant.on("stream-disabled", (stream: any) => {

      if (stream.kind === "video") {
        this.webCamEnable = false;
        let toggleIcon = document.getElementById(`iconvideov-${this.participantId}`);
        let toggleIcon1: any = document.getElementById(`listvideo-${this.participantId}`);
        if (toggleIcon1) {
          toggleIcon1.src = this.videocam_off;
        }
        toggleIcon.innerHTML = 'videocam_off';
      }
      if (stream.kind == "audio") {
        this.micEnable = false;
        let toggleIcon = document.getElementById(`iconaudiov-${this.participantId}`);
        let toggleIcon1: any = document.getElementById(`listmic-${this.participantId}`);
        toggleIcon.innerHTML = 'mic_off';
        if (toggleIcon1) {
          toggleIcon1.src = this.mic_off;
        }
      }
    });

    this.meeting.on("participant-joined", (participant) => {
      let audioElement;
      let videoElement = this.createVideoElement(participant);
      //videoElement.style.transform = "scale(-1,1)"
      this.totalParticipant++;

      if (this.meeting.localParticipant.id !== participant.id) {
        audioElement = this.createAudioElement(participant.id);
        audioElement.style['display'] = 'none'
      }

      participant.on("stream-enabled", (stream) => {

        if (stream.kind === "video") {
          let toggleIcon: any = document.getElementById(`iconvideov-${participant.id}`);
          if (toggleIcon) {
            toggleIcon.innerHTML = 'videocam';
          }
          let toggleIcon1: any = document.getElementById(`listvideo-${participant.id}`);
          if (toggleIcon1) {
            toggleIcon1.src = this.videocam_on;
          }
        }
        if (stream.kind == "audio") {
          let toggleIcon = document.getElementById(`iconaudiov-${participant.id}`);
          if (toggleIcon) {
            toggleIcon.innerHTML = 'mic';
          }
          let toggleIcon1: any = document.getElementById(`listmic-${participant.id}`);
          if (toggleIcon1) {
            toggleIcon1.src = this.mic_on;
          }
        }
        this.setTrack(stream, audioElement, participant, false);
      });
      participant.on("stream-disabled", (stream) => {

        if (stream.kind === "video") {
          let toggleIcon = document.getElementById(`iconvideov-${participant.id}`);
          let toggleIcon1: any = document.getElementById(`listvideo-${participant.id}`);
          if (toggleIcon1) {
            toggleIcon1.src = this.videocam_off;
          }
          if (toggleIcon) {
            toggleIcon.innerHTML = 'videocam_off';
          }
        }
        if (stream.kind == "audio") {
          let toggleIcon = document.getElementById(`iconaudiov-${participant.id}`);
          let toggleIcon1: any = document.getElementById(`listmic-${participant.id}`);
          if (toggleIcon) {
            toggleIcon.innerHTML = 'mic_off';
          }
          if (toggleIcon1) {
            toggleIcon1.src = this.mic_off;
          }
        }
        // this.setTrack(stream, audioElement, participant, false);
      });
      this.videoContainer.nativeElement.appendChild(videoElement);
      this.videoContainer.nativeElement.appendChild(audioElement);
    });

    this.meeting.on("participant-left", (participant) => {

      this.totalParticipant--;
      this.toast.show(`${participant.displayName} has left the meeting`, {
        theme: 'snackbar',
        position: 'top-right'
      })
      let vElement = document?.getElementsByClassName(`v-${participant.id}`);

      vElement[0]?.parentNode?.removeChild(vElement[0]);

      let aElement = document?.getElementById(`a-${participant?.id}`);

      aElement?.parentNode?.removeChild(aElement);


      //remove it from participant list participantId;
      document.getElementById(`p-${participant.id}`)?.remove();
    });

    this.meeting.on("entry-requested", (data) => {
      const { participantId, name, allow, deny } = data;
      //allow()

      //
      const toastRef = this.toast.show(CommonDialogComponent, {
        data: {
          fact: `${data.name} is requesting to join do you wish them to be part of this group?`,
          joinScreen: true
        },
        autoClose: false,
        theme: 'snackbar',
        position: 'top-right'
      });
      toastRef.afterClosed.subscribe((e) => {

        if (e.dismissedByAction) {
          // callback function to accept the request
          allow();
        } else {

          // callback function to reject the request
          deny();
        }
      });
    });

    this.meeting.on("entry-responded", (participantId, decision) => {
      // participantId will be id of participant who requested to join meeting

      if (this.meeting?.localParticipant?.id === participantId) {
        if (decision === "allowed") {
          // entry allowed
          this.meetingStarted = true;

          //this.joinMeetingOnceAdminResponded(this.joinEventDetails)

        } else {
          // entry denied
          //
          this.leaveMeeting()
          this.openSnackBar('Admin has denied you to be part of this group', '')
        }
      }

    });

    this.meeting.on("meeting-joined", () => {
      this.isGroupShareActive.emit(`{
        "groupSharingStarted": true,
        "eventDetails": ${JSON.stringify(this.eventDetails)}
      }`);


    });

    this.meeting.on("meeting-left", () => {

      this.bottomSheet.dismiss()
      this.meetingStarted = false;
      this.isGroupShareActive.emit(undefined);
      this.totalParticipant--
    });

    this.meeting.on("webcam-requested", ({ accept, reject }) => {
      const toastRef = this.toast.show(CommonDialogComponent, {
        data: {
          fact: 'Host is requesting for Web-cam',
          joinScreen: false
        },
        style: {
          width: '300px'
        },
        autoClose: true,
        theme: 'snackbar',
        position: 'top-right',
        duration: 5000
      });
      toastRef.afterClosed.subscribe((e) => {

        if (e.dismissedByAction) {

          // callback function to accept the request
          accept();

        } else {

          // callback function to reject the request
          reject();
        }
      });


    },);

    // Handle Mic Requested
    this.meeting.on("mic-requested", ({ accept, reject }) => {
      const toastRef = this.toast.show(CommonDialogComponent, {
        data: {
          fact: 'Host is requesting you to unmute',
          joinScreen: false
        },
        style: {
          width: '300px'
        },
        autoClose: true,
        theme: 'snackbar',
        position: 'top-right',
        duration: 5000,

      });
      toastRef.afterClosed.subscribe((e) => {

        if (e.dismissedByAction) {
          // callback function to accept the request
          accept();
        } else {
          // callback function to reject the request
          reject();
        }
      });
    });
  }

  setTrack(stream: any, audioElement: any, participant: any, isLocal: any) {
    setTimeout(() => {
      if (stream.kind == "video") {
        if (isLocal) {
          ////  videoCamOff.style.display = "none";
          //  videoCamOn.style.display = "inline-block";
        }

        const mediaStream = new MediaStream();
        mediaStream.addTrack(stream.track);

        let videoElm: any = document.getElementById(`v-${participant.id}`);

        if (videoElm) {

          videoElm.srcObject = mediaStream;
          videoElm
            .play()
            .catch((error: any) =>
              console.error("videoElem.current.play() failed", error)
            );
          participant.setViewPort(videoElm.offsetWidth, videoElm.offsetHeight);
        }

      }
      if (stream.kind == "audio") {
        if (isLocal) {
          // micOff.style.display = "none";
          // micOn.style.display = "inline-block";
          return
        }
        const mediaStream = new MediaStream();
        mediaStream.addTrack(stream.track);
        audioElement.srcObject = mediaStream;
        audioElement
          .play()
          .catch();
      }
    }, 4000)


  }

  createVideoElement(participant: any) {
    console.log(participant, 'createvideo')
    let division;
    division = document.createElement("div");
    division.setAttribute("id", "video-frame-container");
    division.className = `v-${participant.id}`;
    this.videoParticipantContainer = document.getElementsByClassName(`v-${this.participantId}`)
    // this.participantId = participant.id;
    let videoElement = document.createElement("video");
    videoElement.style.margin = '5px'
    videoElement.classList.add("video-frame");
    videoElement.setAttribute("id", `v-${participant.id}`);
    videoElement.setAttribute("playsinline", 'true');
    this.videoElement = document.getElementById(`v-${this.participantId}`)
    let optionsDiv = document.createElement('div')
    optionsDiv.className = 'vid-options-container'

    let endBtn = document.createElement("span");
    endBtn.className = 'end-btn-span'
    endBtn.setAttribute("id", `aclick${participant.id}`);
    if (this.hostUser || this.participantId === participant.id) {
      endBtn.addEventListener('click', (e) => { this.toggleMic(e) })
      endBtn.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px"> mic </mat-icon>`
    } else {
      endBtn.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="color:red;font-size: 18px;cursor: default;">mic </mat-icon>`
    }

    let videoBtn = document.createElement("span");
    videoBtn.className = 'vid-btn-span'
    videoBtn.setAttribute("id", `vclick${participant.id}`);
    if (this.hostUser || this.participantId === participant.id) {
      videoBtn.addEventListener('click', (e) => { this.toggleWebCam(e) })
      videoBtn.innerHTML = `<mat-icon  id=iconvideov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px"> videocam</mat-icon>`
    } else {
      videoBtn.innerHTML = `<mat-icon  id=iconvideov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="color:red;font-size: 18px;cursor: default;">videocam</mat-icon>`
    }
    videoElement.setAttribute("width", "175");
    videoElement.setAttribute("height", "100");
    let nameSpan = document.createElement("span");
    nameSpan.className = 'user-span';
    nameSpan.innerHTML = `${participant.displayName}`;

    division.appendChild(videoElement);
    optionsDiv.appendChild(endBtn)
    optionsDiv.appendChild(videoBtn)
    optionsDiv.appendChild(nameSpan)
    division.appendChild(optionsDiv)
    console.log(participant, 'createvideoend')

    // document.getElementById('videoContainer').appendChild(this.localParticipant)
    return division;
  }

  createLocalParticipant(meeting: any) {
    console.log('local particiant')
    console.log(meeting);
    setTimeout(() => {
      this.participantId = meeting.localParticipant.id;
      this.localParticipant = this.createVideoElement(meeting.localParticipant);

      //  document.getElementById('videoContainer').appendChild(this.localParticipant)
      this.videoContainer?.nativeElement.appendChild(this.localParticipant);
    }, 2000)

  }

  createAudioElement(pId: any) {
    if (pId == this.participantId) {
      return null;
    }
    let audioElement = document.createElement("audio");
    audioElement.setAttribute("autoPlay", "false");
    audioElement.setAttribute("playsInline", "true");
    audioElement.setAttribute("controls", "false");
    audioElement.setAttribute('muted', 'true')
    audioElement.setAttribute("id", `a-${pId}`);
    return audioElement;
  }

  openGroupTemplate(config?: MatBottomSheetConfig) {
    config.panelClass = 'participant-list'
    return this.bottomSheet.open(this.groupTemplate, config);
  }

  openWaitingLobbyTemplate(config?: MatBottomSheetConfig) {
    return this.bottomSheet.open(this.waitingLobbyTemplate, config);
  }
  bottomsheet: any
  openParticipantTemplate(config?: MatBottomSheetConfig) {
    //config.panelClass = 'cus-participant-template'

    this.bottomsheet = this.bottomSheet.open(this.participantListTemplate, config)

    this.bottomsheet.afterOpened().subscribe((res) => {

      let toggleIcon1: any = document.getElementById('listLocalVideo');
      let toggleIcon2: any = document.getElementById('listLocalAudio');
      if (this.webCamEnable) {
        if (toggleIcon1) {
          toggleIcon1.src = this.videocam_on;
        }
      } else {
        if (toggleIcon1) {
          toggleIcon1.src = this.videocam_off;
        }
      }
      if (this.micEnable) {
        if (toggleIcon1) {
          toggleIcon2.src = this.mic_on;
        }
      } else {
        if (toggleIcon1) {
          toggleIcon2.src = this.mic_off;
        }
      }

    })
    return this.bottomSheet;
  }

  leaveMeeting() {
    this.totalParticipant = 1;
    this.meeting?.disableWebcam()
    this.meeting?.muteMic()
    this.meeting?.leave();
    if (this.hostUser) {
      this.hostUser = false;
    }
    this.meetingStarted = false;
  }

  removeStorage() {
    localStorage.removeItem('meetingDetails')
  }

  disableAudio() {
    this.meeting.localParticipant.disableAudio()
  }

  async toggleMic(event?: Event) {
    let toggleIcon2: any = document.getElementById('listLocalAudio');

    let elementId: string = (event?.target as Element).id;
    if (elementId === 'listLocalAudio' || elementId.split('-')[1] == this.meeting.localParticipant.id.split('-')[0]) {

      if (this.micEnable) {
        this.micEnable = false;
        this.micToggleIcon = 'mic_off'
        if (toggleIcon2 != null) {
          toggleIcon2.src = this.mic_off

        }
        this.meeting?.muteMic();

      } else {
        this.micEnable = true;
        this.micToggleIcon = 'mic';
        if (toggleIcon2 != null) {
          toggleIcon2.src = this.mic_on;

        }
        let customAudioTrack = await VideoSDK.createMicrophoneAudioTrack({
          encoderConfig: "high_quality",
          noiseConfig: {
            noiseSuppression: true,
            echoCancellation: true,
            autoGainControl: true,
          },
          microphoneId: ''
        });
        this.meeting?.unmuteMic(customAudioTrack);
      }
    } else {

      const participants = this.meeting.participants;
      let participant;
      if (participants.get(elementId.replace('iconaudiov-', ''))) {
        participant = participants.get(elementId.replace('iconaudiov-', ''));
      } else {
        participant = participants.get(elementId.replace('listmic-', ''));
      }

      if (participant?.micOn) {
        // This will directly disable webcam of particular participant
        participant.disableMic();
      } else {
        participant.enableMic();
      }
    }

  }


  async toggleWebCam(event?: Event) {
    let toggleIcon1: any = document.getElementById('listLocalVideo');
    let elementId: string = (event?.target as Element).id;

    if (elementId === 'listLocalVideo' || elementId.split('-')[1] == this.meeting.localParticipant.id.split('-')[0]) {

      if (this.webCamEnable) {
        this.webCamEnable = false;
        this.webCamToggleIcon = 'videocam_off';
        if (toggleIcon1 != null) {
          toggleIcon1.src = this.videocam_off

        }
        this.meeting?.disableWebcam();
      } else {
        this.webCamEnable = true;
        this.webCamToggleIcon = 'videocam'
        if (toggleIcon1 != null) {
          toggleIcon1.src = this.videocam_on

        }
        this.meeting?.enableWebcam();
      }
    } else {

      const participants = this.meeting.participants;
      let participant;
      if (participants.get(elementId.replace('iconvideov-', ''))) {
        participant = participants.get(elementId.replace('iconvideov-', ''));

      } else {
        participant = participants.get(elementId.replace('listvideo-', ''));
      }
      document.getElementById(`aclick${participant.id}`).setAttribute('style', 'pointer-events:none');
      setTimeout(() => {
        document.getElementById(`aclick${participant.id}`).setAttribute('style', 'pointer-events:auto');;
      }, 5000)

      // This will emit an event called "webcam-requested" to that particular participant
      if (participant?.webcamOn) {
        // This will directly disable webcam of particular participant

        participant.disableWebcam();
      } else {
        //  let toggleIcon = document.getElementById(`iconvideov-${participant.id}`);
        //  toggleIcon.innerHTML = 'videocam';
        participant.enableWebcam();
      }
    }
  }

  openDialog() {
    this.dialog.open(CreateGroupPopupComponent, {
      width: '24vw',
      height: '100%',
      panelClass: 'create-group-modalbox',
      data: {
        eventId: this.eventId,
        isPreScheduleEvent: false,
        isEventStarted: true
      },
    }).afterClosed().subscribe((res) => {
      console.log('===== dialog closed with response: ', res);
      if (res && res.token) {
        this.meetingStarted = res.startMeeting;
        // this.isGroupShareActive.emit('true');
        this.token = res.token;
        this.meetingId = res.meetingId;
        this.customRoomId = res.customRoomId;
        this.inviteUser(res);
        localStorage.setItem('meetingDetails', JSON.stringify(res))
        this.getEventDetails()

        this.startMeeting(this.token, this.meetingId)
      } else if (res && res.invitedEmails) {
        this.inviteUser(res);
      }
    })
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top'
    });
  }

  getDisplayName(item) {
    return item.value;
  }

  getUserDetails() {
    this.sportLightService.getUserDetails().toPromise().then((res: any) => {

      //   this.firstName = (res.firstName).toUpperCase();
      this.userDetails = res;
      res['userId'] = res.userID ? res.userID : res.userId
      localStorage.setItem('userData', JSON.stringify(res));

    }).catch((err: any) => {

    });
  }

  getControlValue(value: string, controlValue: any) {
    if (value === 'mic') {
      return `listmic-${controlValue.value.id}`
    } else {
      return `listvideo-${controlValue.value.id}`
    }
  }

  getControlValueForLocalParticipant(value: string, controlValue: any) {
    if (value === 'mic') {
      return `loclistmic-${controlValue.id}`
    } else {
      return `loclistvid-${controlValue.id}`
    }
  }

  userJoinMeeting(event) {
    if (this.canUserAccessMovie) {
      this.token = event.token;
      this.meetingId = event.roomId;
      this.eventId = event.eventId;
      this.joinEventDetails = event;
      this.meetingStarted = true;
      this.userJoinType = 'JOIN';
      this.customRoomId = event.customRoomId
      // this.isGroupShareActive.emit(event)
      this.getEventDetails()
      this.startMeeting(this.token, this.meetingId)
      this.toast.show(`Requested Host to let you in!`, {
        theme: 'snackbar',
        position: 'top-right',
        duration: 5000
      })
      this.groupSharingService.meetingEndObservable.subscribe((res) => {
        if (res) {
          this.meeting?.leave();
          if (this.hostUser) {
            this.hostUser = false;
          }
          //  this.isGroupShareActive.emit(undefined);
          this.meetingStarted = false;
        }
      })
    } else {
      this.toast.show(`${this.message}`, {
        theme: 'snackbar',
        position: 'top-right',
        duration: 5000
      })
    }

  }

  ngOnChanges(changes: SimpleChanges) {

  }

  filter(val: string): Observable<any[]> {
    // call the service which makes the http-request

    if (val.length > 3) {
      return this.groupSharingService.getPublicUsersList(val)
        .pipe(
          map(response => response.filter(option => {

            return (option.userId != this.eventDetails.userId)

          }))
        )
    }
    return EMPTY;

  }

  inviteUser(dialogResponse: any) {
    if (!dialogResponse.invitedEmails || !dialogResponse.invitedEmails.length) {
      return;
    }

    for (const email of dialogResponse.invitedEmails) {
      const invitationRequest = {
        emailAddress: email,
        invitedUserName: "Invited User",
        invitationSource: InvitationSource.WATCH_PARTY,
        invitationSourceMetadata: {
          watchPartyRequestFlow: WatchPartyRequestFlow.NEW_PARTICIPANT_ADDED,
          watchPartyParticipantRequest: {
            partyType: WatchPartyType.PRIVATE,
            customRoomId: this.customRoomId,
            eventId: this.eventId,
            userIds: []
          }
        }
      }

      this.userInvitationService.inviteNewUser(invitationRequest)
        .then(() => {
          console.log(`user: ${email} invited successfully`);
        });
    }
  }

  addParticipantsToExsistingEvent(userId) {

    if (this.selectedUsers.find((p) => p.userId == userId)) {
      this.toast.show(`Participant has been already added in to this group.`, {
        theme: 'snackbar',
        position: 'top-right',
        duration: 5000
      })
      return
    }
    const obj = {
      "partyType": "PRIVATE",
      "customRoomId": this.customRoomId,
      "eventId": this.eventId,
      "userIds": [
        userId
      ]
    }
    this.groupSharingService.addParticipantToExisitingEvent(obj).subscribe((res) => {

      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(val => {
          return this.filter(val || '')
        })
      )
    }, err => {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(val => {
          return this.filter(val || '')
        })
      )
    })
  }
  exsistingGroup: boolean = false;
  getEventDetails() {
    if (this.hostUser) {
      this.hostUser = false;
    }
    this.groupSharingService.getActiveWatchParty(this.eventId).subscribe((res) => {
      let item = res;
      let userDetails = JSON.parse(localStorage.getItem('userData'))
      if (res) {
        if (this.userJoinType === 'JOIN') {
          this.eventDetails = res.find((v) => v.customRoomId == this.customRoomId)
        } else {
          if (res.filter((v) => v.userId == userDetails.userId).length > 0) {
            this.eventDetails = res.filter((v) => v.userId == userDetails.userId)[0];
            this.exsistingGroup = true;
          } else {
            this.exsistingGroup = false;
          }
        }
        this.hostUserId = this.eventDetails?.userId;
        this.hostUserCustomId = this.eventDetails?.userId + '-sss'
        if (userDetails.userId === this.eventDetails?.userId) {
          this.hostUser = true;
        }
      }
      this.selectedUsers = this.eventDetails?.participants;
    }, err => {

    })
  }

  removeParticipant(item) {

    let participantId = item.key.replace('sss', "")

    this.meeting.participants.get(item.key).remove()
    this.bottomSheet.dismiss()
    let obj = {
      "partyType": "PRIVATE",
      "customRoomId": this.customRoomId,
      "eventId": this.eventId,
      "userIds": [
        participantId
      ]
    }
    this.groupSharingService.removeParticipants(obj).subscribe((res) => {

    }, err => {

    })
  }

  getLocalStream() {
    navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
      this.permissionAllowed = true;
    }).catch((err) => {
      console.error(`you got an error: ${err}`)
      this.openSnackBar('Please allow Camera and Microphone to start the group sharing on spotlight.', '')
      this.permissionAllowed = false;

    });
  }

  closeBottomSheet() {
    this.bottomSheet.dismiss();
  }

  getIsUserHost(item) {
    if (item?.id === this.hostUserCustomId || item?.key === this.hostUserCustomId) {
      return true

    } else {
      return false
    }
  }

  ngOnDestroy() {
    this.meeting?.disableWebcam()
    this.meeting?.muteMic()
    this.leaveMeeting()

    this.meetingStarted = false;
    this.dialog.closeAll()
    // this.groupSharingService.socketObservable.unsubscribe()
    this.bottomSheet.dismiss()
  }

  changeWebcam(id: any) {
    const { deviceId, label } = this.webcams.filter((v) => v.deviceId === id);

    this.meeting?.changeWebcam(deviceId);
  }

  joinExsistingGroup() {
    this.userJoinType = 'START'
    this.getEventDetails()
    if (this.canUserAccessMovie) {
      if (document.getElementById('startGrpBtn')) {
        document.getElementById('startGrpBtn')?.setAttribute('disabled', 'true')
        setTimeout(() => {
          document.getElementById('startGrpBtn')?.setAttribute('disabled', 'false')
        }, 4000)
      }
      navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
        setTimeout(() => {
          this.getHostToken()
        }, 1000)
      }).catch((err) => {
        console.error(`you got an error: ${err}`)
        this.openSnackBar('Please allow Camera and Microphone to start the group sharing on spotlight.', '')
      });
    } else {
      this.toast.show(`${this.message}`, {
        theme: 'snackbar',
        position: 'top-right',
        duration: 5000
      })
    }
  }


  getHostToken() {
    this.groupSharingService.getHostToken(this.eventDetails.eventId, this.eventDetails.customRoomId).subscribe((res) => {
      res.startMeeting = true;
      res.entryRequested = false;
      res.meetingId = this.eventDetails.roomId;
      // this.isGroupShareActive.emit('true');
      res.eventId = this.eventDetails.eventId;
      res.customRoomId = this.eventDetails.customRoomId;
      this.customRoomId = this.eventDetails.customRoomId;
      this.token = res.token;
      this.meetingId = this.eventDetails.roomId;
      this.eventId = this.eventDetails.eventId;
      res.isMeetingJoined = true;
      this.meetingStarted = res.startMeeting;
      res.isAdmin = true;
      this.getEventDetails();
      localStorage.setItem('meetingDetails', JSON.stringify(res))
      this.startMeeting(res.token, this.eventDetails.roomId)
    }, err => {

    })
  }

  getStreamingLink(): void {
    this.sportLightService.getAgilitixStreamingLink(this.eventId).subscribe((response) => {
      if (response.Error !== undefined) {
        this.canUserAccessMovie = false;
        this.message = 'You do not have access to the movie. Please Purshace tickets to be part of any group';
      } else if (response.AccessStatus === 'AccessValid') {
        this.canUserAccessMovie = true;
      } else if (response.AccessStatus === 'BeforeEvent') {
        this.canUserAccessMovie = false;
        this.message = 'Movie Viewing to occur  21-31 March 2024';
      } else if (response.AccessStatus === 'AccessExpired') {
        this.canUserAccessMovie = false;
        this.message = 'Your access to this movie is expired. Please purchase the movie again.';
      }
    }, (error: any) => {
      this.canUserAccessMovie = false;
      this.message = 'You do not have access to the movie. Please Purshace tickets to be part of any group';
    });
  }
}


